module.exports = __webpack_public_path__ + "img/service_icon7.c713bb76.png";